import React from 'react';

const Services = () => {
  return (
    <section className="container my-5"><br/><br/>
      <h3 className="text-center mb-5 section-title">Courier Companies</h3>
      <div className="row g-4">
        <div className="col-lg-4">
          <div className="service card pt-2 h-100 text-center">
            <div className="service-header">
              <i className="fab fa-dhl text-warning" style={{fontSize: '5rem', marginBottom: '1rem'}}></i>
              <h5>DHL Courier</h5>
            </div>
            <div className="service-body p-4">
              <p><strong>Service Area:</strong> <span className="badge bg-success">All Nepal</span></p>
              <p className="mt-3">Partner companies display here you will get courier service</p>
              <a href="#" className="btn btn-outline-primary mt-3 w-100">View Details</a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service card h-100 pt-2 text-center">
            <div className="service-header">
              <i className="fas fa-plane text-info" style={{fontSize: '5rem', marginBottom: '1rem'}}></i>
              <h5>FedEx Cargo</h5>
            </div>
            <div className="service-body p-4">
              <p><strong>Service Area:</strong> <span className="badge bg-primary">Kathmandu Valley</span></p>
              <p className="mt-3">Display here partner companies service area</p>
              <a href="#" className="btn btn-outline-primary mt-3 w-100">View Details</a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="services card h-100 pt-2 text-center">
            <div className="service-header">
              <i className="fas fa-shipping-fast text-danger" style={{fontSize: '5rem', marginBottom: '1rem'}}></i>
              <h5>Local Express</h5>
            </div>
            <div className="service-body p-4">
              <p><strong>Service Area:</strong> <span className="badge bg-warning">All Districts</span></p>
              <p className="mt-3">Just courier service area partner companies</p>
              <a href="#" className="btn btn-outline-primary mt-3 w-100">View Details</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
